"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1394],{

/***/ 91394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92734);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76640);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64198);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22180);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91738);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41464);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92021);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96528);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19599);
/* harmony import */ var components_common_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79307);
/* harmony import */ var components_kit_Chip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99868);
/* harmony import */ var utility_baseURL__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95877);









var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%",
            // height: '21.5rem',
            // maxHeight: '21.5rem',
            background: theme.palette.background.light,
            borderRadius: theme.shape.medium,
            boxShadow: theme.shadows[1],
            padding: "0.4rem",
            position: "relative"
        },
        banner: {
            width: "100%",
            height: "7.2rem",
            position: "relative",
            top: "0",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexDirection: "column"
        },
        boxBanner: {
            width: "100%",
            height: "7.2rem",
            borderRadius: "1.2rem 1.2rem 0 0 "
        },
        bannerImage: {
            borderRadius: "1.2rem 1.2rem 0 0 ",
            background: " linear-gradient(180deg, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.32) 100%) !important"
        },
        bannerComingSoon: {
            width: "100%",
            height: "10.4rem",
            borderRadius: "1.2rem 1.2rem 0 0 ",
            background: "linear-gradient(208.28deg, rgba(0, 0, 0, 0.88) -5.85%, rgba(0, 0, 0, 0.72) 107.56%)",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex"
        },
        advertising: {
            zIndex: 1,
            position: "absolute",
            left: "1.2rem",
            top: "1.2rem"
        },
        logoBox: {
            width: "8.8rem",
            height: "8.8rem",
            boxShadow: "0px 6px 25px -6px rgba(0, 0, 0, 0.18)",
            borderRadius: theme.shape.medium,
            position: "absolute",
            background: theme.palette.background.light,
            top: "3rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    };
});
var SquareStoreItem = function(props) {
    var ref;
    var theme = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var classes = useStyles();
    var baseURL = (0,utility_baseURL__WEBPACK_IMPORTED_MODULE_6__/* .getOldBaseURL */ .v3)();
    var logo = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        var ref, ref1;
        var findingLogo = (ref1 = props === null || props === void 0 ? void 0 : (ref = props.Images) === null || ref === void 0 ? void 0 : ref.find(function(img) {
            return img.SupplierImageTypeID === 1;
        })) === null || ref1 === void 0 ? void 0 : ref1.FileUrl;
        return baseURL + findingLogo;
    }, [
        baseURL,
        props === null || props === void 0 ? void 0 : props.Images
    ]);
    var banner = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        var ref, ref1;
        var findingBanner = (ref1 = props === null || props === void 0 ? void 0 : (ref = props.Images) === null || ref === void 0 ? void 0 : ref.find(function(img) {
            return img.SupplierImageTypeID === 4;
        })) === null || ref1 === void 0 ? void 0 : ref1.FileUrl;
        return baseURL + findingBanner;
    }, [
        baseURL,
        props === null || props === void 0 ? void 0 : props.Images
    ]);
    var tagsStore = props === null || props === void 0 ? void 0 : (ref = props.Tags) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item.CategoryId !== 111111112;
    });
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: classes.root,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: classes.banner,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: classes.boxBanner,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                src: banner,
                                objectFit: "cover",
                                placeholder: "blur",
                                className: classes.bannerImage,
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: classes.logoBox,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                width: "6rem",
                                height: "5.8rem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                    alt: props.alt,
                                    src: logo,
                                    placeholder: "blur",
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        display: "flex",
                        mt: "5rem",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                color: theme.palette.text.dark,
                                variant: "subtitle1",
                                fontWeight: 700,
                                lineHeight: "2.3rem",
                                minHeight: "4.5rem",
                                maxHeight: "4.5rem",
                                children: (props === null || props === void 0 ? void 0 : props.Name) || props.SupplierName
                            }),
                            (props === null || props === void 0 ? void 0 : props.BranchCount) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                color: theme.palette.text.secondary,
                                style: {
                                    marginRight: "1.2rem"
                                },
                                fontWeight: 700,
                                variant: "subtitle1",
                                lineHeight: "2.2rem",
                                children: [
                                    "+ ",
                                    props === null || props === void 0 ? void 0 : props.BranchCount,
                                    " شعبه"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                display: "flex",
                                justifyContent: (tagsStore === null || tagsStore === void 0 ? void 0 : tagsStore.length) >= 2 ? "space-between" : "center",
                                children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(tagsStore === null || tagsStore === void 0 ? void 0 : tagsStore.map(function(tag) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        m: "0.5rem 0.2rem",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_kit_Chip__WEBPACK_IMPORTED_MODULE_3__.ChipKit, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, tag), {
                                            colors: tag.Style,
                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                children: (ref1 = (tag === null || tag === void 0 ? void 0 : tag.label) || (tag === null || tag === void 0 ? void 0 : tag.Text)) !== null && ref1 !== void 0 ? ref1 : "-"
                                            })
                                        }))
                                    });
                                }))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
SquareStoreItem.defaultProps = {
    advertising: true,
    Images: []
};
/* harmony default export */ __webpack_exports__["default"] = (SquareStoreItem);


/***/ }),

/***/ 99868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ChipKit": function() { return /* reexport */ Chip_Chip; }
});

// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(34427);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81663);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(43903);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(22040);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(64293);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(93359);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/styles/makeStyles/makeStyles.js + 8 modules
var makeStyles = __webpack_require__(92021);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/styles/withStyles/withStyles.js + 1 modules
var withStyles = __webpack_require__(78800);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/styles/useTheme/index.js
var useTheme = __webpack_require__(96528);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(2580);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/iconsax-react/dist/esm/TicketDiscount.js
var TicketDiscount = __webpack_require__(3963);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/react/index.js
var react = __webpack_require__(19599);
// EXTERNAL MODULE: ./src/assets/index.js + 240 modules
var assets = __webpack_require__(57730);
// EXTERNAL MODULE: ./src/components/common/Image/index.jsx
var Image = __webpack_require__(79307);
;// CONCATENATED MODULE: ./src/components/kit/Chip/Chip.jsx











var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        info: (0,_define_property/* default */.Z)({
            backgroundColor: "".concat(theme.palette.info[400], " !important"),
            color: "".concat(theme.palette.info.main, " !important"),
            borderRadius: theme.shape.small,
            padding: "0 !important",
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.info.main;
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.1rem 0.4rem !important",
            borderRadius: "0.4rem"
        }),
        error: (0,_define_property/* default */.Z)({
            backgroundColor: "".concat(theme.palette.error[400], " !important"),
            color: "".concat(theme.palette.error.main, " !important"),
            padding: "0.6rem 1rem",
            display: "flex !important",
            flexDirection: "row-reverse !important",
            borderRadius: theme.shape.small,
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.error.main;
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.1rem 0.4rem !important",
            borderRadius: "0.4rem"
        }),
        warning: (0,_define_property/* default */.Z)({
            backgroundColor: "".concat(theme.palette.secondary[300], " !important"),
            color: "".concat(theme.palette.secondary.light, " !important"),
            borderColor: " ".concat(theme.palette.secondary.light, " !important"),
            borderRadius: "".concat(theme.shape.small, "px !important"),
            display: "flex",
            padding: "0.8rem 0.8rem !important",
            flexDirection: "row-reverse",
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.secondary.light;
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.4rem 0.4rem !important",
            borderRadius: "8px !important"
        }),
        success: (0,_define_property/* default */.Z)({
            backgroundColor: "".concat(theme.palette.success2[400], " !important"),
            color: "".concat(theme.palette.success2.main, " !important"),
            padding: "0.8rem 0.8rem !important",
            display: "flex !important",
            flexDirection: "row-reverse !important",
            alignItems: "center",
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.success2.main;
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.1rem 0.4rem !important",
            borderRadius: "0.4rem"
        }),
        online: (0,_define_property/* default */.Z)({
            backgroundColor: "".concat(theme.palette.success[300], " !important"),
            color: "".concat(theme.palette.success.main, " !important"),
            display: "flex",
            flexDirection: "reo-reverse",
            padding: "0.8rem 0.7rem !important",
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.success.main;
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.1rem 0.4rem !important",
            borderRadius: "0.4rem"
        }),
        category: {
            backgroundColor: "".concat(theme.palette.background.light, " !important"),
            color: "".concat(theme.palette.text.dark, " !important"),
            borderColor: " ".concat(theme.palette.info[700], " !important"),
            boxShadow: "".concat(theme.shadows[1], " !important"),
            borderRadius: "".concat(theme.shape.medium, "px !important"),
            padding: "2.3rem 1.6rem !important",
            "&:hover": {
                cursor: "pointer"
            }
        },
        filter: (0,_define_property/* default */.Z)({
            color: "".concat(theme.palette.primary[700], " !important"),
            backgroundColor: " ".concat(theme.palette.primary[200], " !important"),
            borderRadius: "0.8rem !important",
            margin: "0.4rem",
            padding: "0.8rem 0.7rem !important",
            fontSize: "1.4rem",
            fontWeight: 500,
            lineHeight: "2.1rem",
            display: "flex !important",
            flexDirection: "row-reverse !important",
            alignItems: "center",
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.primary[700];
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.1rem 0.4rem !important",
            borderRadius: "0.8rem"
        }),
        primary: {
            color: "".concat(theme.palette.primary[700], " !important"),
            backgroundColor: " ".concat(theme.palette.primary[200], " !important"),
            borderRadius: "0.8rem !important",
            margin: "0.4rem",
            padding: "0.8rem 0.7rem !important",
            fontSize: "1.4rem",
            fontWeight: 500,
            lineHeight: "2.1rem",
            display: "flex !important",
            flexDirection: "row-reverse !important",
            alignItems: "center",
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.primary[700];
                }
            }
        },
        soon: (0,_define_property/* default */.Z)({
            background: "".concat(theme.palette.primary[200], " !important"),
            color: "".concat(theme.palette.text.dark, " !important"),
            padding: "0.6rem 0.8rem",
            display: "flex",
            flexDirection: "row-reverse",
            borderRadius: theme.shape.small,
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor || theme.palette.text.dark;
                }
            }
        }, theme.breakpoints.between("xs", "sm"), {
            padding: "0.1rem 0.4rem !important",
            borderRadius: "0.4rem"
        }),
        advertising: {
            padding: "0.2rem 0.8rem",
            backgroundColor: " ".concat(theme.palette.background.light, " !important"),
            color: "".concat(theme.palette.primary[700], " !important"),
            display: "flex !important",
            flexDirection: "row-reverse !important",
            alignItems: "center",
            borderRadius: theme.shape.small,
            fontSize: "1.2rem !important",
            boxShadow: theme.shadows[1]
        },
        disabled: {
            backgroundColor: "".concat(theme.palette.text.disabled, " !important"),
            borderColor: "".concat(theme.palette.text.disabled, " !important"),
            color: "".concat(theme.palette.text.primary, " !important"),
            cursor: "not-allowed !important",
            "& svg": {
                fill: "".concat(theme.palette.text.disabled, " !important")
            }
        },
        iconColor: {
            "& svg": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor;
                }
            }
        }
    };
});
var CustomChip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: {
            fontSize: theme.typography.subtitle1.fontSize,
            fontWeight: 500,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center"
        },
        icon: {},
        outlined: {
            backgroundColor: "".concat(theme.palette.common.white, " !important"),
            borderColor: theme.palette.grey[300]
        }
    };
})(Chip/* default */.Z);
var ChipKit = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var colors = props.colors, iconColor = props.iconColor, disabled = props.disabled, label = props.label, rest = (0,_object_without_properties/* default */.Z)(props, [
        "colors",
        "iconColor",
        "disabled",
        "label"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles({
        iconColor: iconColor
    });
    var handleSwitchAvatar = react.useMemo(function() {
        switch(colors){
            case "Style1":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "1rem",
                    height: "1rem",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                        src: assets/* Megaphone */.Jo6
                    })
                });
            case "Style3":
            case "Style4":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "element-center",
                    style: {
                        display: "flex",
                        flexDirection: ""
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDiscount/* default */.Z, {
                        variant: "Outline",
                        color: colors === "Style3" ? theme.palette.error.main : theme.palette.success2.main,
                        size: rest.size === "small" ? 18 : 20
                    })
                });
            default:
                break;
        }
    }, [
        colors,
        rest.size,
        theme.palette.error.main,
        theme.palette.success2.main
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomChip, (0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.info, (ref = [
            "Style6",
            "info"
        ]) === null || ref === void 0 ? void 0 : ref.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.success, (ref1 = [
            "Style4",
            "success"
        ]) === null || ref1 === void 0 ? void 0 : ref1.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.category, colors === null || colors === void 0 ? void 0 : colors.includes("category")), (0,_define_property/* default */.Z)(_obj, classes.filter, colors === null || colors === void 0 ? void 0 : colors.includes("filter")), (0,_define_property/* default */.Z)(_obj, classes.primary, colors === null || colors === void 0 ? void 0 : colors.includes("primary")), (0,_define_property/* default */.Z)(_obj, classes.soon, (ref2 = [
            "Style2"
        ]) === null || ref2 === void 0 ? void 0 : ref2.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.warning, (ref3 = [
            "warning"
        ]) === null || ref3 === void 0 ? void 0 : ref3.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.advertising, (ref4 = [
            "Style1"
        ]) === null || ref4 === void 0 ? void 0 : ref4.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.online, (ref5 = [
            "Style5"
        ]) === null || ref5 === void 0 ? void 0 : ref5.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.error, (ref6 = [
            "Style3",
            "error"
        ]) === null || ref6 === void 0 ? void 0 : ref6.includes(colors)), (0,_define_property/* default */.Z)(_obj, classes.iconColor, iconColor), (0,_define_property/* default */.Z)(_obj, classes.disabled, disabled), _obj)),
        disabled: disabled,
        size: "small",
        label: label,
        avatar: handleSwitchAvatar
    }, rest));
};
ChipKit.defaultProps = {};
/* harmony default export */ var Chip_Chip = (ChipKit);

;// CONCATENATED MODULE: ./src/components/kit/Chip/index.js



/***/ })

}]);